export default __webpack_public_path__ + "static/media/white_onion.95502a55.png";